import { Link } from 'react-router-dom';
import { Phone, Mail, ShieldCheck, Zap } from 'lucide-react';

export const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer data-testid="footer" className="bg-slate-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
          {/* Contact Info */}
          <div data-testid="footer-contact">
            <div className="flex items-center gap-3 mb-6">
              <img
                src="https://customer-assets.emergentagent.com/job_2ff46b05-db4f-4a7e-b966-4ede5e5bc6f8/artifacts/47fi3pb2_logo.png"
                alt="Solid Repair LLC"
                className="h-10 w-auto"
              />
              <div>
                <h3 className="font-['Barlow_Condensed'] text-lg font-bold uppercase tracking-tight">
                  Solid Repair LLC
                </h3>
                <p className="text-amber-500 text-xs">Electrical Services</p>
              </div>
            </div>
            <div className="space-y-3">
              <a
                href="tel:+19047137611"
                data-testid="footer-phone"
                className="flex items-center gap-3 text-slate-300 hover:text-amber-500 transition-colors"
              >
                <Phone className="w-5 h-5 text-amber-500" />
                <span>(904) 713-7611</span>
              </a>
              <a
                href="mailto:kary1907@live.com"
                data-testid="footer-email"
                className="flex items-center gap-3 text-slate-300 hover:text-amber-500 transition-colors"
              >
                <Mail className="w-5 h-5 text-amber-500" />
                <span>kary1907@live.com</span>
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div data-testid="footer-links">
            <h4 className="font-['Barlow_Condensed'] text-lg font-bold uppercase tracking-tight mb-6">
              Quick Links
            </h4>
            <nav className="space-y-3">
              <Link
                to="/"
                className="block text-slate-300 hover:text-amber-500 transition-colors"
              >
                Home
              </Link>
              <Link
                to="/about"
                className="block text-slate-300 hover:text-amber-500 transition-colors"
              >
                About Us
              </Link>
              <Link
                to="/gallery"
                className="block text-slate-300 hover:text-amber-500 transition-colors"
              >
                Gallery
              </Link>
            </nav>
          </div>

          {/* Credentials */}
          <div data-testid="footer-credentials">
            <h4 className="font-['Barlow_Condensed'] text-lg font-bold uppercase tracking-tight mb-6">
              Credentials
            </h4>
            <div className="space-y-4">
              <div className="flex items-start gap-3">
                <ShieldCheck className="w-5 h-5 text-amber-500 flex-shrink-0 mt-0.5" />
                <div>
                  <p className="text-white font-medium text-sm">Associate in Applied Science</p>
                  <p className="text-slate-400 text-xs">Construction Electricity Management</p>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <Zap className="w-5 h-5 text-amber-500 flex-shrink-0 mt-0.5" />
                <div>
                  <p className="text-white font-medium text-sm">Technical Certificate</p>
                  <p className="text-slate-400 text-xs">Construction Electricity Assistant</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Copyright */}
        <div className="mt-12 pt-8 border-t border-slate-700">
          <p className="text-center text-slate-400 text-sm">
            &copy; {currentYear} Solid Repair LLC. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};
